export default __webpack_public_path__ + "static/arrow-booking-889a8200df93692c4bed06b3e5fcbf17.svg";